<template>
  <b-card>
    <b-button
      class="pull-right"
      size="sm"
      variant="transparent"
      @click="onClose"
      >
      <i class="fa fa-times" />
    </b-button>
    <div v-if="info.hasOwnProperty('selected') && info.selected">
      <small>{{$t('InfoPanel.query') + getProperty(info, [['info', 'formatted', locale], ['info', 'formatted', oppLocale]], '')}}</small>
      <div v-if="info.hasOwnProperty('valid') && info.valid">
        {{$t('InfoPanel.within') + getProperty(info, [['name', locale], ['name', oppLocale]], '')}}
      </div>
      <div v-else>
        {{$t('InfoPanel.noInfo')}}
      </div>
    </div>
    <div v-else>
      <h5>{{getProperty(info, [['name', locale], ['name', oppLocale]], '')}}</h5>
      <small>{{getProperty(info, [['agency', locale], ['agency', oppLocale]], '')}}</small>
    </div>
    <div v-if="info.hasOwnProperty('address') && Array.isArray(info.address)">
      <div v-for="address in info.address">
        <hr/>
        <div>{{getProperty(address, [[locale], [oppLocale]], '')}}</div>
        <div v-if="address.hasOwnProperty('contact') && Array.isArray(address.contact)">
          <div v-for="contact in address.contact">
            <small>
              {{$t('InfoPanel.contact.' + contact.type, '')}}
              <a target="_blank" v-if="contact.type === 'tel'" :href="'tel:' + contact.value">{{contact.value}}</a>
              <a target="_blank" v-else-if="contact.type === 'email'" :href="'mailto:' + contact.value">{{contact.value}}</a>
              <span v-else>{{contact.value}}</span>
            </small>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import langEn from "./lang/en.json";
import langZh from "./lang/zh.json";

import common from '@/mixins/common.js'

export default {
  name: "InfoPanel",
  mixins: [common],
  components: {
    
  },
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
  mounted() {
    this.$i18n.add("en", langEn);
    this.$i18n.add("zh", langZh);
  },
}
</script>

<style>
</style>
